import { CommonModule } from "@angular/common";
import { AiViewDisplayComponent } from "./search-display/ai-view-display/ai-view-display.component";
import { MapDisplaySearchComponent } from "./search-display/map-display/map-display-search.component";
import { GridDisplaySearchComponent } from "./search-display/grid-display/grid-display-search.component";
import { PropertyAnalystDisplayComponent } from "./search-display/property-analyst-display/property-analyst-display.component";
import { NgModule } from "@angular/core";
import { SearchEnhancedComponent } from "./search-enhanced/search-enhanced.component";
import { SearchSettingsComponent } from "./search-settings/search-settings.component";
import { ToolbarInfoPanelComponent } from "./toolbar-info/toolbar-info-panel.component";
import { CompoundMainComponent } from "./main/compound-main.component";
import { ListSearchResultsComponent } from "./search-display/search-results/list-result/list-search-results.component";
import { GridSearchResultsComponent } from "./search-display/search-results/grid-result/grid-search-results.component";
import { DomService } from "../viewer-components/services/internal-services/dom.service";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from "@angular/material-moment-adapter";
import { MAT_BUTTON_CONFIG } from "@angular/material/button";
import { PhoenixViewerService } from "../viewer-components/services/internal-services/viewer-services/phoenix-viewer.service";

@NgModule({
  imports: [
    CommonModule,
    AiViewDisplayComponent,
    MapDisplaySearchComponent,
    GridDisplaySearchComponent,
    PropertyAnalystDisplayComponent,
    GridSearchResultsComponent,
    ListSearchResultsComponent,
    SearchEnhancedComponent,
    SearchSettingsComponent,
    ToolbarInfoPanelComponent,
    CompoundMainComponent,
  ],
  exports: [
    AiViewDisplayComponent,
    MapDisplaySearchComponent,
    GridDisplaySearchComponent,
    PropertyAnalystDisplayComponent,
    GridSearchResultsComponent,
    ListSearchResultsComponent,
    SearchEnhancedComponent,
    SearchSettingsComponent,
    ToolbarInfoPanelComponent,
    CompoundMainComponent,
  ],
})
export class CompoundsComponentsModule {}
